import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Notificacion } from "../../../interfaces/notificaciones/notificacion.interface";
import { EnvAppService } from "../../services/env-app.service";
import { AuthService } from "../../../services/auth.service";
import { Router } from "@angular/router";
import { UnifyNotificationService } from "src/app/core/services/unify-notification.service";
import { UnifyNotification } from "src/app/core/interfaces/unify_notification.interface";

@Component({
  selector: "app-notificaciones",
  templateUrl: "./notificaciones.component.html",
  //styleUrls: ['./notificaciones.component.css']
})
export class NotificacionesComponent implements OnInit {
  constructor(
    //private services:EnvAppService,
    private services: UnifyNotificationService,
    public session: AuthService,
    private router: Router
  ) {}

  @Output() cant_notificaciones: EventEmitter<number> = new EventEmitter();

  notificaciones: UnifyNotification[] = [];

  ngOnInit(): void {
    this.services
      .getNotifications(this.session.auth?.id + "")
      .subscribe((result) => {
        //console.log(result)
        this.notificaciones = result;
        this.cant_notificaciones.emit(this.notificaciones.length);
      });
  }

  ir(notificacion: UnifyNotification) {
    if (!notificacion.url_accion) return;

    this.services.openNotification(notificacion.id + "").subscribe({
      next: (resp) => {
        window.location.replace(notificacion.url_accion);
      },
    });
  }
}
